import api from './api';

const integrationConsentApi = {
  async listPending(params = {}) {
    const { data } = await api.get('/api/companies/me/integration-consents', { params });
    return data;
  },
  async approve(id) {
    const { data } = await api.post(`/api/companies/me/integration-consents/${id}/approve`);
    return data;
  },
  async deny(id, reason) {
    const { data } = await api.post(`/api/companies/me/integration-consents/${id}/deny`, { reason });
    return data;
  }
};

export default integrationConsentApi;
